import React, { useEffect } from 'react';
import './ShowcaseModal.css';

interface ShowcaseModalProps {
  isOpen: boolean;
  onClose: () => void;
  content: string;
  title?: string;
  image?: string;
}

const ShowcaseModal: React.FC<ShowcaseModalProps> = ({ isOpen, onClose, content, title, image }) => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="showcase-modal-overlay" onClick={onClose}>
      <div className="showcase-modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="showcase-modal-close" onClick={onClose}>
          ✕
        </button>

        {title && (
          <div className="showcase-modal-header">
            <h2>{title}</h2>
          </div>
        )}

        <div className="showcase-modal-content">
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      </div>
    </div>
  );
};

export default ShowcaseModal;
